export default "__VITE_ASSET__BVvsDpXj__"